import * as utils from '../utils'

export const getAll = () => utils.get('/regulators')
export const get = ({ code }) => utils.get(`/regulators/${code}`)
